import { Component, Input, OnChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Line } from '@models/line.model';

@Component({
  selector: 'app-lift-tool-filters',
  templateUrl: './lift-tool-filters.component.html',
  styleUrls: ['./lift-tool-filters.component.scss']
})
export class LiftToolFiltersComponent implements OnChanges {
  @Input() form: UntypedFormGroup;
  @Input() lines: Line[] = [];
  @Input() allLinesLabel = '';

  lineOptions: Line[] = [];

  ngOnChanges() {
    this.lineOptions = [
      { id: null, name: this.allLinesLabel } as Line,
      ...(this.lines || [])
    ];
  }

  control(name: string): UntypedFormControl {
    return this.form.get(name) as UntypedFormControl;
  }
}
